export const KEY = "5f472b7acba333cd8a035ea85a0d4d4c";
export const BASE_URL = "https://api.openweathermap.org/data/2.5";